import React, { useState } from 'react'
import AccordionComponent from './AccordionComponent';
import CircularProgressWithLabel from './CircularProgressWithLabel'
import './style.css'

const BuildWithAI = () => {
    const totalSections = 4;
    const [completedSections, setCompletedSections] = useState(0); 

    function updateMainProgress(totalCount, completedCount){
        //this function only gets called when sections are fully complete
        //state.completed_section = state.completed_section+1;
        setCompletedSections(completedCount);
        //console.log("updated completed section: ", completedSections);
    }

    return (
        <div>
            <h3>My #DigitalDefenceHack 2020 progress</h3>
            <div style={{
                backgroundColor: '#CC2E72',
                width: '100%',
                color: '#ebd1d1',
                fontWeight: 'bolder',
                padding: '10px 0 0 15px',
                borderRadius: '10px',
                marginBottom: '20px',
                display: 'flex',
            }}>
                <span>
                    <CircularProgressWithLabel
                        total_section = {totalSections} 
                        completed_section = {completedSections}/>
                </span>
                <div style={{
                    marginLeft: '1rem',

                }}>
                    COMPLETED
            <h1 style = {{marginTop: '0px'}}>{completedSections}/4</h1>                    
                </div>
            </div>
            <AccordionComponent updateMainProgress={updateMainProgress} />
        </div>
    )
}

export default BuildWithAI
